'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Validator the base class
 */
class Validator {
    excludes;
    name = 'validator';
    constructor(opt) {
        let { excludes } = opt;
        if (!Array.isArray(excludes)) {
            excludes = [];
        }
        this.excludes = excludes;
        if (new.target.name) {
            this.name = new.target.name;
        }
    }
    test(value) {
        return this.excludes.every(ex => !Object.is(ex, value));
    }
}

class StringValidator extends Validator {
    constructor(opt = {}) {
        super(opt);
    }
    test(value) {
        return 'string' === typeof value;
    }
    isEmail(val) {
    }
}
const inst$3 = new StringValidator();

class ObjectValidator extends Validator {
    constructor(opt = { pattern: '' }) {
        super(opt);
    }
    test(value) {
        return !!(value
            && value instanceof Object
            && Object.getPrototypeOf(value) === Object.prototype);
    }
    isPlain(value) {
        if (!this.test(value)) {
            return false;
        }
        return Object.getOwnPropertyNames(value)
            .every(prop => value.hasOwnProperty(value, prop));
    }
    hasSubValue(value, prop) {
        const sub = value[prop];
        if (!value.hasOwnProperty(prop)) {
            return false;
        }
        return !(Number.isNaN(sub) || sub === null || sub === undefined);
    }
    isEmpty(value) {
        return Object.getOwnPropertyNames(value).length === 0;
    }
}
const inst$2 = new ObjectValidator();

class NumberValidator extends Validator {
    constructor(opt = { pattern: '' }) {
        super(opt);
    }
    test(val) {
        return typeof val === 'number' && !Number.isNaN(val);
    }
    isInt(val) {
        return Number.isInteger(val);
    }
    isFloat(val) {
        return typeof val === 'number' && !this.isInt(val);
    }
}
const inst$1 = new NumberValidator();

const realValueValidator = new Validator({
    excludes: [null, undefined, NaN],
    pattern: ''
});
function fromValidator(validator) {
    return (value) => {
        return validator.test(value);
    };
}
function wrapOwnPropCheck(test, owner) {
    return (value, prop) => {
        if (prop) {
            if (typeof value === 'object' && value.hasOwnProperty(prop)) {
                return test.call(owner, value[prop]);
            }
            return false;
        }
        return test.call(owner, value);
    };
}
const isRealValue = wrapOwnPropCheck(realValueValidator.test, realValueValidator);
const isStr = wrapOwnPropCheck(inst$3.test, inst$3);
const isNum = wrapOwnPropCheck(inst$1.test, inst$1);
const isObject = wrapOwnPropCheck(inst$2.test, inst$2);
const isUndef = wrapOwnPropCheck((value) => typeof value === 'undefined', null);
const isFn = wrapOwnPropCheck((value) => typeof value === 'function', null);
const isPrim = wrapOwnPropCheck((value) => inst$3.test(value) || inst$1.test(value) || typeof value === 'boolean', null);

class ArrayValidator extends Validator {
    constructor(opt = { pattern: '' }) {
        super(opt);
    }
    test(value) {
        return Array.isArray(value);
    }
    isClean(value) {
    }
}
const inst = new ArrayValidator();

const lib = { isNum };
function add(validator, name) {
    name = name ?? validator.name;
    if (validator.hasOwnProperty(name)) {
        throw new ReferenceError('name exists');
    }
    Object.defineProperty(lib, name, {
        configurable: false,
        enumerable: true,
        get() {
            return validator;
        },
        set(v) {
            throw new SyntaxError(`Validator "${name}" exists!`);
        }
    });
}

exports.Validator = Validator;
exports.add = add;
exports.av = inst;
exports.fromValidator = fromValidator;
exports.isFn = isFn;
exports.isNum = isNum;
exports.isObject = isObject;
exports.isPrim = isPrim;
exports.isRealValue = isRealValue;
exports.isStr = isStr;
exports.isUndef = isUndef;
exports.lib = lib;
exports.nv = inst$1;
exports.ov = inst$2;
exports.rv = realValueValidator;
exports.sv = inst$3;
exports.wrapOwnPropCheck = wrapOwnPropCheck;
